import { lazy } from 'react';

export const TeacherAssessmentPage = lazy(() => import('./TeacherAssessmentPage'));
